import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { DiaryEvent } from "../../models/diary-event";
import { DiaryDetailTypes } from "../../constants/diary-detail-types";
import {DiaryEventStatusProvider} from "@diary/services/diary-event-status-provider";

@Component({
  selector: 'mojo-diary-event-details',
  templateUrl: './diary-event-details.component.html',
  styleUrls: ['./diary-event-details.component.scss']
})
export class DiaryEventDetailsComponent implements OnInit {
  @Output() onClicked = new EventEmitter<any>();
  @Input() diaryEvent: DiaryEvent;
  @Input() isUndated: boolean;

  constructor(private diaryEventStatusProvider: DiaryEventStatusProvider) {

  }

  ngOnInit() {
  }

  clicked(event) {
    this.onClicked.emit();
  }

  getDetailTypeText(): string {
      if (this.diaryEvent.DetailType != undefined && this.diaryEvent.DetailType != null && this.diaryEvent.DetailType.trim().length > 0)
        return `${this.diaryEvent.DetailType}${this.diaryEvent.MatchType == 'Notice' ?  ' - Notice' : ''}`;
      else
        return `${this.diaryEvent.FallbackText}`;
  }

  public getEventStatusText(): string {

    return this.isUndated ? this.diaryEventStatusProvider.getUndatedEventStatus(this.diaryEvent) : this.diaryEventStatusProvider.getDatedEventStatus(this.diaryEvent);
  }

  public isExpiry() {
    return this.getDetailTypeText() === DiaryDetailTypes.Expiry;
  }

  public isOption() {
    return this.getDetailTypeText() === DiaryDetailTypes.Option;
  }

  public isReview() {
    return this.getDetailTypeText() === DiaryDetailTypes.Review;
  }

  public isOther() {
    return this.getDetailTypeText() === DiaryDetailTypes.Other;
  }

  getColor(event: DiaryEvent): string {
    // temporary example colours until we get the actual mapping from SIT
    switch (event.DetailType || event.FallbackText) {
    case DiaryDetailTypes.Option:
      return '5px solid rgb(37,137,249)';
    case DiaryDetailTypes.Review:
      return '5px solid rgb(124,204,3)';
    case DiaryDetailTypes.Expiry:
      return '5px solid rgb(221,0,119)';
    default:
      return '5px solid rgb(251,126,1)';
    }
  }
}

